export const isEmpty = (value: any) => {
  return (
    value === undefined ||
    value === null ||
    (typeof value === 'string' && value.trim() === '') ||
    (Array.isArray(value) && value.length === 0) ||
    (typeof value === 'object' &&
      !Array.isArray(value) &&
      !Object.keys(value).length)
  );
};

export const isEmptyIncludeCheckDateRange = (value: any) => {
  const normal = isEmpty(value);
  if (normal) return normal;
  else {
    return (
      typeof value === 'object' &&
      !Array.isArray(value) &&
      (('startDate' in value &&
        !value.startDate &&
        'endDate' in value &&
        !value.endDate) ||
        ('start' in value &&
          !value.start &&
          'end' in value &&
          !value.end))
    );
  }
};

export const dashIfEmpty = (value: any) => {
  return isEmpty(value) ? '-' : value;
};
